<template>
	<div class="ui basic active tab">
		<div class="ui">
			<div class="ui blue rounded button right floated available-products" :class="activeMerchant && activeMerchant.opus && !$auth.user().social_number ? 'disabled' : ''" @click="showAvailableProductsModal = !showAvailableProductsModal">
				<i class="plus icon"/>
				{{ $t('pages.wait_list.available_products') }}
			</div>
			<h1 class="header">
				{{ $t('pages.wait_list.header') }}
			</h1>
		</div>

		<div class="ui divider"></div>

		<service-filters @changed="applyFilters"></service-filters>

		<div class="ui two column stackable grid waitlist-details">
			<div class="sixteen wide mobile eight wide tablet seven wide computer column">
				<div class="servicescontainer" v-if="waitlistsubscriptions && waitlistsubscriptions.data.length > 0">
					<transition-group name="page">
						<service
							v-for="waitlistsubscription in waitlistsubscriptions.data"
							:key="waitlistsubscription.id"
							:waitlistid="waitlistsubscription.id"
							:open="activeService && activeService.id === waitlistsubscription.id"
							:ref="`service-${waitlistsubscription.id}`"
							@selectService="selectService">
						</service>
					</transition-group>

					<div v-if="waitlistsubscriptions.last_page > 1">
						<div class="ui pagination menu" v-if="waitlistsubscriptions.last_page <= 5">
							<a class="item" v-for="amount in waitlistsubscriptions.last_page" :key="amount" :class="{ 'active' : amount === currentServicePage }" @click="currentServicePage = amount">
								{{ amount }}
							</a>
						</div>
						<div class="ui pagination menu" v-else>
							<a class="icon item" @click="currentServicePage--" v-if="currentServicePage > 1">
								<i class="angle left icon"/>
							</a>
							<a class="item">{{ currentServicePage }}</a>
							<a class="icon item" @click="currentServicePage++" v-if="currentServicePage !== waitlistsubscriptions.last_page">
								<i class="angle right icon"/>
							</a>
						</div>
					</div>
				</div>


				<div class="ui centered aligned icon header" v-else>
					<i class="close icon"/>
					{{ $t('pages.wait_list.no_waitinglist') }}
				</div>
			</div>

			<div class="sixteen wide mobile eight wide tablet nine wide computer column">
				<div class="servicescontainer">
					<transition name="page">
						<service-details
							:service="activeService"
							:waitlist="true"
							v-if="activeService">
						</service-details>
					</transition>
				</div>
			</div>
		</div>

    <modal ref="modal" :active="isCardExpired" :title="$t('modals.expired_card.title')" icons="big alarm" @acceptmodal="openCheckoutPageToUpdate">
      <h4>{{ $t('modals.expired_card.header', {firstname: this.$auth.user().firstname, surname: this.$auth.user().surname}) }}</h4>
      <span v-html="$t('modals.expired_card.body', {container: $t('globals.container.waitlist'), product_name: this.waitlistWithExpiredCard.productName})"></span>
    </modal>

    <modal ref="modal" :active="showUpdateWaitlistNotice" :title="$t('modals.payment_system_update.title')" icons="big alarm" @acceptmodal="openCheckoutPage" @denymodal="closeUpdateModal">
      <h4>{{ $t('modals.payment_system_update.header', {firstname: this.$auth.user().firstname, surname: this.$auth.user().surname}) }}</h4>
      <span v-html="$t('modals.payment_system_update.body', {container: $t('globals.container.waitlist'), product_name: this.waitListActiveProductName})"></span>
    </modal>

		<available-products-modal :active="showAvailableProductsModal" :waitlist="true"></available-products-modal>
	</div>
</template>

<script>
	export default {
		name: 'WaitingList',

		data () {
			return {
				waitlistsubscriptions: null,
				activeService: null,
				currentServicePage: 1,
				showAvailableProductsModal: false,
				isCardExpired: false,
				waitlistWithExpiredCard: {},
				showUpdateWaitlistNotice: false,
				waitListActiveProductName: '',
				filter: 'active|unset|deletable|overdue'
			}
		},

		watch: {
			activeMerchant: function () {
				this.fetchWaitListSubscriptions(this.activeMerchant.id, true)
			},

      activeService () {
        if (this.activeService) {
          if (this.activeService.pricing && this.activeService.pricing.type === 'recurring') {
            if (this.activeService.nets_details !== null) {
              if (this.activeService.nets_details.payment_id === null ||
                this.activeService.nets_details.subscription_id === null
              ) {
                this.showUpdateWaitlistNotice = true
                this.waitListActiveProductName = this.activeService.product.name
              } else {
                this.showUpdateWaitlistNotice = false
              }
            }
          } else {
            this.showUpdateWaitlistNotice = false
          }
        }
      },

			currentServicePage: function () {
				this.fetchWaitListSubscriptions(this.activeMerchant.id, true)
			},

			filter: function () {
				this.fetchWaitListSubscriptions(this.activeMerchant.id, true)
			}
		},

		mounted () {
			this.fetchWaitListSubscriptions(this.activeMerchant.id, true)

      this.fetchWaitlistsWithExpiredCard()

			this.$events.$on('updatesubscriptions', (data, isCancelling) => {
				const waitlistData = data
				this.fetchWaitListSubscriptions(this.activeMerchant.id, false, isCancelling)
					.then(() => {
						this.$events.$emit('refreshservice', waitlistData)
					})
			})

			this.$events.$on('subscription-cancelled', (data, isCancelling) => {
				this.fetchWaitListSubscriptions(this.activeMerchant.id, false, isCancelling)
			})
		},

		methods: {
			fetchWaitListSubscriptions (merchantid, fetchFirst = false, isCancelling = false) {
        this.activeService = null

				return new Promise((resolve, reject) => {
					if (merchantid) {
						this.axios.get(`merchants/${merchantid}/waitlistsubscriptions`, {
							params: {
								page: this.currentServicePage,
								perPage: 4,
								filter: this.filter
							}
						})
							.then(({data}) => {
                // Sorting waitlists to show overdue firstly
                for (let key in data.data) {
                  let waitlist = data.data[key]

                  if (waitlist.status === 'overdue') {
                    data.data.splice(key, 1)
                    data.data.splice(0, 0, waitlist)
                  }
                }

								this.waitlistsubscriptions = data

								if (fetchFirst || isCancelling) {
									if (data && data.data.length > 0) {
                    let firstWaitlist = data.data[0]
										this.fetchService(firstWaitlist.id)
											.then(WaitListSubscription => {
												this.activeService = WaitListSubscription
											})
									} else {
										this.activeService = null
									}
								}

								resolve(data)
							}, error => {
								reject(error)
							})
					} else {
						reject('Missing Merchant ID')
					}
				})
			},

      fetchWaitlistsWithExpiredCard () {
        if (this.activeMerchant) {
          this.axios.get(`users/${this.$auth.user().id}/expiredCardWaitlists?merchant_id=${this.$store.getters.activeMerchant.id}`)
            .then((response) => {
              if (response.status === 200) {
                this.isCardExpired = true
                this.waitlistWithExpiredCard = response.data
              }
            })
            .catch((error) => {
              console.log(error.data)
            })
        }
      },

			selectService (service) {
				this.activeService = null

				setTimeout(() => {
					this.activeService = service
				}, 250)
			},

			fetchService (waitlistid) {
				return new Promise((resolve, reject) => {
					if (waitlistid) {
						this.axios.get(`waitlistsubscriptions/${waitlistid}`)
							.then(({data}) => {
								this.activeService = data
								resolve(data)
							}, error => {
								reject(error)
							})
					} else {
						reject('Missing Service ID')
					}
				})
			},

			applyFilters (filters) {
				this.filter = filters
				this.fetchWaitListSubscriptions(this.activeMerchant.id, true)
			},

      openCheckoutPageToUpdate () {
        if (Object.keys(this.waitlistWithExpiredCard).length > 0) {
          this.$router.push({name: 'checkout', params: { containerId: this.waitlistWithExpiredCard.id }, query: {container: 'waitlist', subscriptionId: this.waitlistWithExpiredCard.netsSubscriptionId}})
        }
      },

      openCheckoutPage () {
        this.$router.push({name: 'checkout', params: { containerId: this.activeService.id }, query: {container: 'waitlist'}})
      },

      closeUpdateModal () {
        this.showUpdateWaitlistNotice = false
      }
		},

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			}
		},

		beforeDestroy () {
			this.$events.$off('updatesubscriptions')
		}
	}
</script>

<style lang="scss" scoped>
	.servicescontainer {
		display: flex;
		width: 100%;
		position: relative;
		flex-flow: column;
	}

  @media only screen and (max-width: 450px) {
    .header {
      font-size: 1.7rem;
    }
  }

  @media only screen and (max-width: 370px) {
    .available-products {
      font-size: 0.85rem;
    }
  }

  @media only screen and (max-width: 350px) {
    .header {
      font-size: 1.5rem;
    }
    .waitlist-details {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/merchant/WaitingList.vue